export function FadeIn(props: any)  {

return (
	<div className="fade-in w-100 h-100">
		{props.children}
	</div>
  );
}
